import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  menu: {
    "& .MuiPaper-root": {
      backgroundColor: "#FAFAFA",
    },
    "& .MuiList-padding": {
      padding: "0px",
    },
  },
  menuContainer: {
    width: 280,
    maxHeight: 190,
    marginTop: "4px",
    borderRadius: 12,
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
    "& > ul": {
      padding: "10px 5px !important",
    },
  },
  button: {
    backgroundColor: "transparent !important",
    height: "32px",
    padding: "5px",
    alignItems: "center",
    transition: "none",
    marginRight: "16px",
    borderRadius: "15px",
    cursor: "pointer",
    "& span": {
      display: "flex",
      gap: "10px",
    },
  },
  buttonActive: {
    backgroundColor: "#DAEAF8 !important",
    height: "32px",
    alignItems: "center",
    padding: "5px",
    transition: "none",
    marginRight: "16px",
    borderRadius: "15px",
    cursor: "pointer",
    "& span": {
      display: "flex",
      gap: "10px",
    },
  },
  languageSelect: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "6px 12px",

    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ddd",
    },
  },
  languageSelectContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    padding: "4px 8px",
  },
  languageSelectContainerSelected: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    padding: "4px 8px",
    width: "100%",
    background: "#EDF5FB",
    borderRadius: "8px",
  },
  flagImage: {
    height: "24px",
    width: "24px",
    borderRadius: "12px",
    objectFit: "cover",
  },
  languageDescription: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#667085",
  },
  languageDescriptionSelected: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#308CDB",
  },
  checkIcon: {
    marginLeft: "auto",
  },
}));

export default styles;
